<template>
  <div class="post-form nc-post-form">
    <post-form-head
      :title.sync="post.title"
      :description.sync="post.description"
    ></post-form-head>

    <post-form-media
      :media="media"
      @update:media="value => $emit('update:media', value)"
    ></post-form-media>

    <post-form-additional
      :post.sync="post"
      :media="media"
    ></post-form-additional>
  </div>
</template>

<script>

import PostFormHead from '@/components/PostFormHead';
import PostFormMedia from '@/components/PostFormMedia';
import PostFormAdditional from '@/components/PostFormAdditional';

export default {
  name: 'PostForm',
  components: {
    PostFormHead,
    PostFormMedia,
    PostFormAdditional,
  },
  props: {
    postId: true,
    post: {
      required: true,
    },
    media: {
      required: true,
    },
  },
  watch: {
    post: 'emitPostUpdate',
    media: 'emitMediaUpdate',
  },
  methods: {
    emitPostUpdate() {
      this.$emit('update:post', this.post);
    },
    emitMediaUpdate() {
      this.$emit('update:media', this.media);
    },
  },
};
</script>

<style>

.nc-post-form .wrapper {
  margin: 30px 0;
}

.nc-post-form label {
  display: block;
  font-weight: bold;
}

.nc-post-form input {
  width: 100%;
  outline: none;
  border: solid 1px rgba(0,0,0, .1);
  background: #fff;
  padding: 4px;
}

.nc-post-form textarea {
  width: 100%;
  outline: none;
}

.nc-post-form .btn {
  margin: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/PostForm.vue